import angular from 'angular';

(function() {
    'use strict';

    angular.module('app.core').component('labelValue', {
        bindings: {
            label: '@', // Libellé à traduire
            value: '<', // Valeur associé au libellé
            classesValue: '<' // Style du champ value
        },
        templateUrl: require('./label-value.html')
    });
})();
